<section class="search-bar-container">
  <div class="logo">
    <img src="../../../../../assets/images/esaamlg_logo.svg" alt="Logo" />
  </div>

  <div class="main-bar">
    <h2>{{ selectedItem }}</h2>

    <div class="actions">
      <!--    <app-language-switcher></app-language-switcher>-->
      <a *ngIf="selectedItem == 'Dashboard' && canCreateCase()" [routerLink]="['/case-management/case-creation']" class="default-btn"><i class="fa-solid fa-plus"></i>New Case</a>
      <a *ngIf="selectedItem == 'Case Management' && canCreateCase()" [routerLink]="['/case-management/case-creation']" class="default-btn"><i class="fa-solid fa-plus"></i>New Outgoing Case</a>
      <a *ngIf="selectedItem == 'Working Groups'" [routerLink]="['/working-groups/create']" class="default-btn"><i class="fa-solid fa-plus"></i>New Working Group</a>
      <a *ngIf="selectedItem == 'Users' && canCreateUser()" [routerLink]="['/users/create']" class="default-btn"><i class="fa-solid fa-plus"></i>New User</a>
      <a *ngIf="selectedItem == 'FIU Management' && canCreateFiu()" [routerLink]="['/fiu-management/create']" class="default-btn"><i class="fa-solid fa-plus"></i>New FIU</a>
      <!--    Commented out until needed-->
      <!--    <div class="language-dropdown">-->
      <!--      <button class="change-language"><i class="fa-solid fa-flag"></i></button>-->
      <!--      <ul class="language-list">-->
      <!--        <li (click)="changeLanguage('en-GB')">English (UK)</li>-->
      <!--        <li (click)="changeLanguage('de-LU')">German (Luxembourg)</li>-->
      <!--      </ul>-->
      <!--    </div>-->
    </div>
  </div>
</section>
